import { render } from "./ChangePwd.vue?vue&type=template&id=ca258dee&scoped=true"
import script from "./ChangePwd.vue?vue&type=script&lang=js"
export * from "./ChangePwd.vue?vue&type=script&lang=js"

import "./ChangePwd.vue?vue&type=style&index=0&id=ca258dee&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca258dee"]])

export default __exports__